import { mediaQuery, useMediaQueryResult } from 'hooks/useMediaQueryResult';

export const useIsDesktop = () => useMediaQueryResult(mediaQuery.desktopSmallUp);
